<template>
    <div>
        <pagination
            v-if="!showPageLoader && showPagination"
            :pagination="pagination"
            @pagination-changed="paginationChanged"
            @button-clicked-previous="applySearch('previous')"
            @button-clicked-next="applySearch('next')"
        ></pagination>
        <status-update-popup @updateStatus="submit"></status-update-popup>
        <base-toast></base-toast>
    </div>
</template>

<script>
import pagination from '@/components/Pagination.vue'
import { mapGetters } from 'vuex'
import statusUpdatePopup from '@/components/popups/StatusUpdatePopup.vue'
import resource from '@/api/resource'
import requestV2 from '@/utils/request-v2'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        pagination,
        statusUpdatePopup,
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        reset: {
            type: Number,
        },
        reload: {
            type: Number,
        },
        showPagination: {
            type: Boolean,
            required: true,
        },
        encrypted: {
            type: Boolean,
            default: false,
        },
        useV2: {
            type: Boolean,
            default: false,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            resourceApi: null,
            pagination: {},
            isActive: true, // Used to ignore stale API responses when user navigates away
        }
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'dataSegmentId',
            'showPageLoader',
            'selectedItem',
            'onSubmit',
        ]),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            this.applySearch()
        },
        reload(value){
            this.getRecords()
        },
        dataSegmentId(value) {
            if (value) {
                this.applySearch()
            }
        },
        onSubmit(value) {
            if (value) {
                this.submit(value)
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        this.resourceApi = this.useV2 ? new resource(this.path, requestV2) : new resource(this.path)
    }, // End of Component > created

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.dataSegmentId) {
            this.getRecords()
        }
    }, // End of Component > mounted
    beforeDestroy() {
        this.isActive = false
        this.$store.dispatch(`setData`, [])
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getRecords() {
            this.$store.dispatch(`setData`, [])
            this.$store.commit('showPageLoader', true)
            try {
                this.query.dataSegmentId = (this.query && this.query.dataSegmentId)? this.query.dataSegmentId:this.dataSegmentId
                this.query.dataSegmentId = this.query.dataSegmentId=='skip'? null:this.query.dataSegmentId
                if(this.$route.path.includes('customer-verification'))
            {
                this.query.dataSegmentId = this.query.dataSegmentId == this.dataSegmentId ? null : this.query.dataSegmentId
            }

            console.log('this.query', this.resourceApi)
                let { data } = await this.resourceApi.list(this.query)
                // Ignore response if user navigated away (prevents stale data overwriting current page)
                if (!this.isActive) return

                if (data && data.data) {
                    if(this.encrypted) {
                        data.data = this.$decryptData(data.data);
                    }
                    if (data.data.length) {
                        // console.log('data.data', data.data)
                        // Get all data in items
                        this.$store.dispatch(`setData`, data.data)
                    }

                    if (data.pagination) {
                        let pagination = data.pagination
                        this.$store.commit(`setTotalRecords`, pagination.total)
                        // Show Pagination
                        this.query.startAt = pagination.current
                        this.pagination = pagination
                        this.pagination.perPage = this.query.perPage
                        this.pagination.totalRecords = data.data.length
                    }
                }

                // False the page loader after the list has been loaded
                this.$store.commit('showPageLoader', false)
                this.$store.commit('setLoading', false)
            } catch (error) {
                if (!this.isActive) return
                this.$store.commit('showPageLoader', false)
                this.$store.dispatch(`setData`, [])
                this.$store.commit('setLoading', false)
                // this.$store.commit('setError', error)
            }
        },
        paginationChanged(limit) {
            this.query.perPage = limit || 10
            this.query.startAt = 1
            this.pagination.perPage = limit || 10

            this.getRecords()
        }, // End of paginationChanged() method
        //apply filters and get matching records
        applySearch(type) {
            this.pagination.perPage = this.query.perPage
            this.query.startAt = 1
            if (type && type == 'next') {
                this.query.startAt = this.pagination.next
            }

            if (type && type == 'previous') {
                this.query.startAt = this.pagination.current - 1
            }

            this.$store.dispatch(`setData`, [])
            //this.$store.commit('setLoading', true)
            this.getRecords()
        }, // End of applySearch() method

        async submit(record) {
            this.$store.commit('setLoading', true)
            let item = {}
            if (record.type && record.type == 'status') {
                item = JSON.parse(JSON.stringify(this.selectedItem))
                item.status = record.status
            } else {
                item = record
                delete item.status
            }

            try {
                if (item._id) {
                    let formData = {...item};
                    if(this.encrypted) {
                        formData = {data: this.$encryptData(item)};
                    }
                    var { data } = await this.resourceApi.update(item._id, formData)
                } else {
                    item.dataSegmentId = (this.query && this.query.dataSegmentId)?this.query.dataSegmentId:this.dataSegmentId
                    var { data } = await this.resourceApi.store(item)
                }
                if (data) {
                    this.$store.commit('setSuccess', data.message)
                    //setTimeout(this.$parent.reset = new Date().getTime(), 3000)
                }
            } catch (error) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', error)
            }
        },
    },
}
</script>
